import moment, { Moment } from "moment";
import React from "react";
import Datetime from "react-datetime";

import inputElementStyles from "../styles/InputElements.module.css";
import "react-datetime/css/react-datetime.css";
import "./DatetimePicker.css"; // need this to custom style the date picker

interface Props {
  onDatetimeChange: (value: string | Moment) => void;
  selectedDate?: string;
  isValidDate?: (currentDate: Moment, selectedDate: Moment) => boolean;
  renderDay?: (
    props: React.TdHTMLAttributes<HTMLTableCellElement>,
    currentDate: Moment,
    selectedDate: Moment
  ) => JSX.Element;
}

const DatetimePicker: React.FC<Props> = (props) => {
  const formattedDate = props.selectedDate
    ? moment(props.selectedDate).format("DD/MM/YYYY h:mm A")
    : undefined;
  return (
    <div>
      <Datetime
        isValidDate={props.isValidDate}
        value={formattedDate}
        dateFormat={"DD/MM/YYYY"}
        closeOnSelect={false}
        inputProps={{
          className: `${inputElementStyles.Padding} ${inputElementStyles.Input}`,
          placeholder: formattedDate,
          readOnly: true,
          style: {
            // fix to make datepicker not too big for left sidemenu
            maxWidth: "122px",
            fontSize: "0.8rem",
          },
        }}
        onChange={props.onDatetimeChange}
        renderDay={props.renderDay}
      />
    </div>
  );
};

export default DatetimePicker;
